import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  dialogWrapper: {
    width: '420px',
    borderRadius: theme.other.spacing._24,

    [theme.fn.smallerThan('sm')]: {
      width: '100%',
    },
  },

  container: {
    padding: theme.other.spacing._24,
    paddingTop: theme.other.spacing._16,
    position: 'relative',
  },

  content: {
    paddingTop: theme.other.spacing._8,
  },

  titleContainer: {
    textAlign: 'center',
    marginBottom: theme.other.spacing._8,
  },

  descriptionContainer: {
    textAlign: 'center',
    marginBottom: theme.other.spacing._32,
  },

  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16,
    width: '100%',
  },
}));

export default useStyles;
